const messages = {
  "ui.emailBody.actions.attachFiles": "Attach files",
  "ui.emailBody.actions.dynamicVariables.searchPlaceholder": "Search dynamic variables",
  "ui.emailBody.actions.dynamicVariables.someEntityDontHaveValue":
    "One or more recipient does not have a value for this dynamic variable",
  "ui.emailBody.actions.filesAttach.largeFilesWarning.description":
    "The size of your attempted upload exceeds 24 MB. Please compress the file and try again.",
  "ui.emailBody.actions.filesAttach.largeFilesWarning.title": "Attachment size limit exceeded",
  "ui.emailBody.actions.formatting": "Formatting options",
  "ui.emailBody.actions.generateEmail": "AI Writer",
  "ui.emailBody.actions.insertDynamicVar": "Insert dynamic variable",
  "ui.emailBody.actions.insertLink": "Insert link",
  "ui.emailBody.actions.insertResourceLink": "Insert Resource Link",
  "ui.emailBody.actions.preview": "Preview",
  "ui.emailBody.actions.removeResourceLink": "Remove Resource Link",
  "ui.emailBody.attachedFileList.download": "Download",
  "ui.emailBody.attachedFileList.fileSize": "{size, number, ::K}MB",
  "ui.emailBody.attachedFileList.remove": "Remove attachment",
  "ui.emailBody.dynamicVariables.noResult.subTitle":
    "There are no dynamic variables that match this search.",
  "ui.emailBody.dynamicVariables.noResult.title": "No results",
  "ui.emailBody.dynamicVariables.someEntitiesMissingData.company":
    "Some companies are missing data for this variable",
  "ui.emailBody.dynamicVariables.someEntitiesMissingData.description":
    "When a variable is missing, it will show up blank.",
  "ui.emailBody.dynamicVariables.someEntitiesMissingData.ok": "Okay",
  "ui.emailBody.dynamicVariables.someEntitiesMissingData.person":
    "Some people are missing data for this variable",
  "ui.emailBody.emailUnsubscribeLink.checkboxLabel": "Add unsubscribe link to email footer",
  "ui.emailBody.emailUnsubscribeLink.checkboxTooltip":
    "Email laws require an unsubscribe link for all bulk emails sent for commercial purposes. If this bulk email is being sent for relationship or transactional purposes, it is not required. If a recipient unsubscribes, they will be automatically excluded from all emails when this box is checked.",
  "ui.emailBody.emailUnsubscribeLink.linkLabel": "Unsubscribe",
  "ui.emailBody.imageModal.addLink": "Add Link",
  "ui.emailBody.imageModal.altTextDescription":
    "Alt text is a brief image description that helps visually impaired users via screen readers and appears if images don't load.",
  "ui.emailBody.imageModal.altTextTitle": "Alt Text",
  "ui.emailBody.imageModal.change": "Change",
  "ui.emailBody.imageModal.description": "Description",
  "ui.emailBody.imageModal.editAltText": "Edit alt text",
  "ui.emailBody.imageModal.goToLink": "Go to link:",
  "ui.emailBody.imageModal.linkTitle": "Link",
  "ui.emailBody.imageModal.ok": "Okay",
  "ui.emailBody.imageModal.remove": "Remove",
  "ui.emailBody.imageModal.size.bestFit": "Best Fit",
  "ui.emailBody.imageModal.size.original": "Original Size",
  "ui.emailBody.imageModal.size.small": "Small",
  "ui.emailBody.linkModal.change": "Change",
  "ui.emailBody.linkModal.goToLink": "Go to link:",
  "ui.emailBody.linkModal.insertLink": "Insert Link",
  "ui.emailBody.linkModal.linkText": "Link Text",
  "ui.emailBody.linkModal.okay": "Okay",
  "ui.emailBody.linkModal.preview": "Preview",
  "ui.emailBody.linkModal.remove": "Remove",
  "ui.emailBody.linkModal.title": "Insert Link",
  "ui.emailBody.linkModal.url": "URL",
  "ui.emailBody.resourceLink.downloadLinkText": "Download",
  "ui.emailBody.resourceLink.downloadTooltip": "Download resource Link",
  "ui.emailBody.resourceLink.notFound": "Not Found",
  "ui.emailBody.resourceLink.removeTooltip": "Remove resource Link",
  "ui.emailBody.resourceLink.restricted": "Restricted",
  "ui.emailBody.urlFormItem.preview": "Preview",
  "ui.emailBody.urlFormItem.url": `URL`,
  "ui.emailBody.urlFormItem.validation.urlInvalid": `Please enter valid URL`,
  "ui.emailBody.urlFormItem.validation.urlRequired": `Please enter URL`,
} as const;

export default messages;
